"use client";

import { lensConfiguratorHeaderTitleMap } from "@/apiUtils/constants";
import Logo from "@/assets/logos/doctor_m_logo.svg?react";
import { TranslationData } from "@/common/lib/types";
import { CLink } from "@/components/common/customLink/CustomLink";
import { Stepper } from "@/components/ui/stepper/Stepper";
import { currentIndexParser } from "@/utils/lensConfigurator";
import { useMemo, useState } from "react";
import ConfirmationModal from "../components/ConfirmationModal";
import { useConfiguratorContext } from "../context/Provider";
import { stepTitles } from "../resource/config";
import Help from "./Help";

interface IProps {
  locale: string;
  hideSteps?: boolean;
  onClose: () => void;
  translations: TranslationData;
  hideCloseButton?: boolean;
}

const LCPHeader = ({
  translations,
  onClose,
  locale,
  hideSteps,
  hideCloseButton = false,
}: IProps) => {
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const { currentStep, steps, skippedSteps, exitModalConfig } = useConfiguratorContext();

  const { titles, current, headerTitle } = useMemo(() => {
    const displaySteps = steps.filter((step) => !skippedSteps.includes(step));
    return {
      current: currentIndexParser(currentStep, displaySteps),
      titles: displaySteps.map((step) => ({ id: `${step}--label`, label: stepTitles[step] })),
      headerTitle:
        lensConfiguratorHeaderTitleMap?.[currentStep] ?? lensConfiguratorHeaderTitleMap.DEFAULT,
    };
  }, [steps, skippedSteps, currentStep]);

  const handleCloseModal = () => {
    onClose?.();
  };

  const handleToggleConfirmModal = () => {
    setOpenConfirmModal((prev) => !prev);
  };

  return (
    <div className="mb-9 hidden justify-between gap-16 border-b py-6 lg:flex">
      <div className="w-full max-w-[12.188rem]">
        <CLink href=" ">
          <Logo className="h-auto w-full" />
        </CLink>
      </div>
      <div className="block md:hidden">
        <h6>{translations?.lensConfigurator?.[headerTitle]}</h6>
      </div>
      {!hideSteps && (
        <div className="w-full">
          <Stepper
            activeStep={current}
            steps={titles.map((t) => translations?.lensConfigurator?.[t.label] || "")}
          />
        </div>
      )}
      <div className="flex-shrink-0">
        <Help
          locale={locale}
          translations={translations}
          onCloseLensConfigurator={hideCloseButton ? undefined : handleToggleConfirmModal}
        />
      </div>
      <ConfirmationModal
        open={openConfirmModal}
        onConfirm={handleCloseModal}
        onCancel={handleToggleConfirmModal}
        imgURL={exitModalConfig?.enableMedia ? exitModalConfig.media : ""}
        slots={{
          cancel:
            translations?.lensConfigurator
              ?.lens_config_exit_lens_configurator_overlay_no_button_label || "",
          confirm:
            translations?.lensConfigurator
              ?.lens_config_exit_lens_configurator_overlay_yes_button_label || "",
          title:
            translations?.lensConfigurator
              ?.lens_config_exit_lens_configurator_overlay_description || "",
        }}
      />
    </div>
  );
};

export default LCPHeader;
